export default {"src":"/_next/static/media/youtube.646fcdaf.ico","height":266,"width":274,"blurWidth":0,"blurHeight":0};